import { useTranslation } from "react-i18next";
import SEOHead from "../components/shared/SEOHead.jsx";
import JsonLd from "../components/shared/JsonLd.jsx";
import { buildBreadcrumbJsonLd } from "../utils/jsonld.js";
import SimplePage from "../components/shared/SimplePage.jsx";
import NewsletterEmbed from "../components/newsletter/NewsletterEmbed.jsx";

export default function Newsletter({ lang }) {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead lang={lang} path="/newsletter" title={t("nav.newsletter")} />
      <JsonLd
        data={buildBreadcrumbJsonLd(
          [
            { name: t("nav.home"), path: "/" },
            { name: t("nav.newsletter"), path: "/newsletter" },
          ],
          lang
        )}
      />
      <SimplePage title={t("nav.newsletter")}>
        <NewsletterEmbed lang={lang} />
      </SimplePage>
    </>
  );
}
